import { TIntlDictionary } from 'types/i18n';
import { stringOrVoid } from 'utils/validation';
import {
  phoneLikeRexExp,
  stringIsEmpty,
  stringLengthMoreThan,
} from 'utils/stringUtils';
import { TFormValidation } from 'types/utils';
import { ClientProfileFormValues } from 'types/state';
import {
  INPUT_POSITION_MAX_LENGTH,
  INPUT_FIRST_NAME_MAX_LENGTH,
  INPUT_LAST_NAME_MAX_LENGTH,
  INPUT_MIDDLE_NAME_MAX_LENGTH,
  INPUT_COMPANY_MAX_LENGTH,
  INPUT_PHONE_MAX_LENGTH,
} from 'utils/constants';

export const validateClientProfileFormValues = (i18n: TIntlDictionary) => (
  values: ClientProfileFormValues
): TFormValidation<ClientProfileFormValues> => ({
  firstName: stringOrVoid(
    stringIsEmpty(values.firstName),
    i18n.inputValidationRequired
  ),
  lastName: stringOrVoid(
    stringIsEmpty(values.lastName),
    i18n.inputValidationRequired
  ),
  middleName: stringOrVoid(
    stringIsEmpty(values.middleName),
    i18n.inputValidationRequired
  ),
  company: stringOrVoid(
    stringIsEmpty(values.company),
    i18n.inputValidationRequired
  ),
  position: stringOrVoid(
    stringIsEmpty(values.position),
    i18n.inputValidationRequired
  ),
  phone: stringOrVoid(
    stringIsEmpty(values.phone),
    i18n.inputValidationRequired
  ),
  location: stringOrVoid(
    values.location === null,
    i18n.inputValidationRequired
  ),
});

export const validateImmediatelyClientProfileFormValues = (
  i18n: TIntlDictionary
) => (
  values: ClientProfileFormValues
): TFormValidation<ClientProfileFormValues> => ({
  firstName: stringOrVoid(
    stringLengthMoreThan(values.firstName, INPUT_FIRST_NAME_MAX_LENGTH),
    i18n.inputValidationMaxLength(INPUT_FIRST_NAME_MAX_LENGTH)
  ),
  lastName: stringOrVoid(
    stringLengthMoreThan(values.lastName, INPUT_LAST_NAME_MAX_LENGTH),
    i18n.inputValidationMaxLength(INPUT_LAST_NAME_MAX_LENGTH)
  ),
  middleName: stringOrVoid(
    stringLengthMoreThan(values.middleName, INPUT_MIDDLE_NAME_MAX_LENGTH),
    i18n.inputValidationMaxLength(INPUT_MIDDLE_NAME_MAX_LENGTH)
  ),
  company: stringOrVoid(
    stringLengthMoreThan(values.company, INPUT_COMPANY_MAX_LENGTH),
    i18n.inputValidationMaxLength(INPUT_COMPANY_MAX_LENGTH)
  ),
  phone: stringOrVoid(
    stringLengthMoreThan(values.phone, INPUT_PHONE_MAX_LENGTH),
    i18n.inputValidationMaxLength(INPUT_PHONE_MAX_LENGTH)
  ),
  position: stringOrVoid(
    stringLengthMoreThan(values.position, INPUT_POSITION_MAX_LENGTH),
    i18n.inputValidationMaxLength(INPUT_POSITION_MAX_LENGTH)
  ),
});

export const sanitizeClientProfileFormChange = (
  inputElement: HTMLInputElement | HTMLTextAreaElement
): boolean => {
  if (inputElement.name === 'phone') {
    return phoneLikeRexExp.test(inputElement.value);
  }

  return true;
};
